class ProductFeatures extends HTMLElement {
  connectedCallback() {
    this.features = this.querySelectorAll('.product-feature');
    this.contentWrapper = this.querySelector('.product-feature-wrapper');
    this.setupFeatures();
  }

  setupFeatures() {
    const notEmpty = Array.from(this.features).find(i => i.dataset.isEmpty === 'false');
    if(!notEmpty) {
      this.remove();
      return;
    }
    let firstAvailable = null;
    this.features.forEach((i, k) => {
      if(i.dataset.isEmpty === 'true') {
        i.classList.add('hidden');
        return;
      }
      if(firstAvailable === null) {
        firstAvailable = k;
      }
      i.querySelector('.product-feature-title').addEventListener('click', this.handleChangeFeature.bind(this, k));
    })
    this.setFeature(firstAvailable);
  }

  setFeature(index) {
    const feature = this.features[index];
    if(!feature) {
      return;
    }
    const content = feature.querySelector('.product-feature-content').cloneNode(true);
    content.classList.remove('hidden');
    this.contentWrapper.innerHTML = '';
    this.contentWrapper.append(content);
    this.querySelectorAll('.product-feature[data-state="active"]').forEach(i => {
      i.setAttribute('data-state', 'inactive');
    })
    feature.setAttribute('data-state', 'active');
  }

  handleChangeFeature(index) {
    this.setFeature(index);
  }
}

customElements.define('product-features', ProductFeatures);